import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-business-partner-help',
    templateUrl: './business-partner-help.component.html',
    styleUrls: ['./business-partner-help.component.scss'],
})
export class BusinessPartnerHelpComponent implements OnInit, OnDestroy {
    showB2BHint = false;
    error = false;
    invalidToken = false;
    params: { [key: string]: string };

    private unsubscribe$: Subject<void> = new Subject<void>();

    constructor(private route: ActivatedRoute) {}
    ngOnInit(): void {
        this.route.queryParams.pipe(takeUntil(this.unsubscribe$)).subscribe((qp) => {
            this.showB2BHint = decodeURIComponent(qp['showB2BHint'] || '') === 'true';
            this.error = decodeURIComponent(qp['error'] || '') === 'true';
            this.invalidToken = decodeURIComponent(qp['invalid-token'] || '') === 'true';

            if (decodeURIComponent(qp['tokenv2'] || '') && !this.invalidToken) {
                this.params = {
                    tokenv2: decodeURIComponent(qp['tokenv2']),
                };
            }

            if (decodeURIComponent(qp['countryCode'] || '')) {
                this.params = {
                    ...this.params,
                    countryCode: decodeURIComponent(qp['countryCode']),
                };
            }
        });
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
